import {
  CATEGORY_PATH_TO_GENDER,
  everythingElseId,
} from '../../categories/constants';
import { TOP_LEVEL_CATEGORIES } from '../../filters/constants';
import { type GetBreadcrumbRequestGender } from '../aliases';
import { type SearchFilters } from '../useSearchFilters';

export function getFiltersFromPath(categoryPath: string): Pick<
  SearchFilters,
  'groups' | 'productTypes' | 'isKids'
> & {
  gender?: GetBreadcrumbRequestGender;
} {
  if (!categoryPath) {
    return {};
  }

  const segments = categoryPath.split('/').filter(Boolean);
  const gender = CATEGORY_PATH_TO_GENDER[segments[0]];
  const isKids = segments[0] === 'kids';
  const isEverythingElse = segments[0] === everythingElseId;

  const isTopLevelCategory =
    TOP_LEVEL_CATEGORIES.has(segments[0]) || isEverythingElse;

  if (segments.length > 2) {
    return {
      gender,
      isKids,
      groups: segments[1],
      productTypes: [segments[2]],
    };
  }

  if (segments.length > 1) {
    const productTypesIndex = isTopLevelCategory ? 2 : 1;

    return {
      gender,
      isKids,
      groups: isTopLevelCategory ? segments[1] : segments[0],
      productTypes: Boolean(segments[productTypesIndex])
        ? [segments[productTypesIndex]]
        : undefined,
    };
  }

  return {
    gender,
    isKids,
    groups: isTopLevelCategory ? undefined : segments[0],
  };
}
